import type { Logger } from './types';
import { ConsoleLogger } from './implementations/console-logger';

/**
 * Logger service that manages logger implementations
 * Automatically initializes Sentry and uses Sentry logger if available, falls back to console logger
 */
export class LoggerService {
  private logger: Logger;
  private isInitialized = false;

  constructor() {
      this.logger = new ConsoleLogger();
  }

  /**
   * Get the logger instance
   */
  getLogger(): Logger {
    return this.logger;
  }

  /**
   * Check if Sentry logger is being used
   */
  isSentryEnabled(): boolean {
    return this.isInitialized;
  }
}

// Create singleton instance
let loggerServiceInstance: LoggerService | null = null;

/**
 * Get the logger service singleton instance
 */
export function getLoggerService(): LoggerService {
  if (!loggerServiceInstance) {
    loggerServiceInstance = new LoggerService();
  }
  return loggerServiceInstance;
}

/**
 * Initialize the logger service (and Sentry if configured)
 * This should be called before React renders
 */
export function initLogger(): void {
  getLoggerService();
}

/**
 * Get the logger instance
 * This is the main export that should be used throughout the application
 */
export function getLogger(): Logger {
  return getLoggerService().getLogger();
}
